import React, { useEffect, useRef, useState } from "react";
import { Button, message, Pagination, Spin, Tabs } from "antd";

import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout";
import StatisticsMainLayout from "./statistics/StatisticsMainLayout";
import BoardsContainer from "./BoardsContainer";

import { controller } from "./controller";
import { isNotEmpty } from "../../utils";
import "./styles.css";
import "./styles.css";

const tabs = [
  { key: "all", label: "All", children: null },
  { key: "automated", label: "Automated", children: null },
  { key: "manual", label: "Manual", children: null },
];

export default function PatientBoardMain() {
  const [selectedBoardStatistics, setSelectedBoardStatistics] = useState(undefined);
  const [createNewBoard, setCreateNewBoard] = useState(false);
  const [loadingBoards, setLoadingBoards] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [allBoards, setAllBoards] = useState(null);
  const [boards, setBoards] = useState(null);
  const [page, setPage] = useState(1)
  const [totalNumBoards, setTotalNumBoards] = useState(1)

  const boardsContainer = useRef(null);

  // Get all boards
  async function getAllBoards() {
    try {
      setLoadingBoards(true);
      const response = await controller.getAllBoards(page, activeTab);
      const newBoard = response.json.results;
      console.log(newBoard);
      setAllBoards(newBoard);
      setTotalNumBoards(response.json.total_count)
    } catch (err) {
      message.error("Something went wrong while getting boards");
      console.error(err);
    } finally {
      setLoadingBoards(false);
    }
  }
  useEffect(function () {
    getAllBoards();
  }, [page]);

  // Rmove this from location storage if exists
  useEffect(function () {
    if (localStorage.getItem("patient-from-patient-board-for-treatment")) {
      localStorage.removeItem("patient-from-patient-board-for-treatment");
    }
  }, []);

  // Scroll automatically to the very left when clicked on add for adding a new board.
  useEffect(
    function () {
      if (!createNewBoard) return;

      const scrollToWidth = boardsContainer.current.scrollWidth + 400;
      boardsContainer.current && boardsContainer.current.scrollTo({ left: scrollToWidth, behavior: "smooth" });
    },
    [createNewBoard]
  );

  // Filtering boards based on board type.
  useEffect(
    function () {
      console.log("allBoards", allBoards);
      if (!isNotEmpty(allBoards)) return;
      if (activeTab === "automated") {
        setBoards(allBoards.filter((board) => board.type === "automated"));
      } else if (activeTab === "manual") {
        setBoards(allBoards.filter((board) => board.type === "manual" && board.real_manual));
      } else {
        setBoards(allBoards);
      }
    },
    [activeTab, allBoards]
  );

  return (
    <React.Fragment>
      <DashboardLayout>
        {selectedBoardStatistics !== undefined ? (
          <StatisticsMainLayout setSelectedBoardStatistics={setSelectedBoardStatistics} selectedBoardStatistics={selectedBoardStatistics} />
        ) : (
          <div style={{ padding: 20, marginBottom: 70 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ marginBottom: 0, fontSize: 20, fontWeight: 500 }}>Automation Engine</p>

              <Button type="primary" style={{ padding: "15px 45px", fontSize: 12 }} onClick={() => setCreateNewBoard(true)}>
                Add
              </Button>
            </div>

            {/* Show the boards if there is any */}
            {createNewBoard || (allBoards && allBoards.length > 0) ? (
              <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
                <Tabs defaultActiveKey="all" items={tabs} onChange={(key) => setActiveTab(key)} style={{ marginTop: 30, marginLeft: 20 }} />

                <BoardsContainer
                  setSelectedBoardStatistics={setSelectedBoardStatistics}
                  setCreateNewBoard={setCreateNewBoard}
                  boardsContainer={boardsContainer}
                  createNewBoard={createNewBoard}
                  boards={boards}
                  onBoardCreated={getAllBoards}
                />
                <div style={{ padding: "20px", marginTop: "100px" }}>
                  <Pagination current={page} onChange={p => setPage(p)} total={totalNumBoards} />
                </div>

              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 30,
                  height: 676,
                  boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)",
                  borderRadius: 10,
                  marginTop: 30,
                }}
              >
                {loadingBoards ? (
                  <Spin size="large" style={{ alignSelf: "center" }} />
                ) : (
                  <>
                    <p style={{ marginBottom: 0, fontSize: 16, fontWeight: 500, width: 700, textAlign: "center" }}>
                      Board are where works gets done. On a board, you can move cards between lists to keep projects, tasks, and more on track
                    </p>

                    <Button type="primary" style={{ padding: "20px 80px" }} onClick={() => setCreateNewBoard(true)}>
                      Create Your First List
                    </Button>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </DashboardLayout>
    </React.Fragment>
  );
}
